<template>
  <section class="tsName">
    <section>{{reasonData.ShowReason}}</section>
    <div v-if="reasonData.Comment" class="allTsName">{{reasonData.Comment}}</div>
  </section>
</template>
<script>
export default {
  name: 'showReason',
  model: {
    prop: 'reasonData',
    event: 'changeValue'
  },
  props: {
    reasonData: {
      type: Object,
      default: function () {
        return { ReasonCode: '', ShowReason: '', Comment: '' }
      }
    }
  }
}
</script>
<style scoped>
  .tsName {
    position: relative;
    cursor: pointer;
  }
  .allTsName {
    transform: scale(0.9);
    display: none;
    top: 13px;
    position: absolute;
    padding: 10px;
    -webkit-box-shadow: 1px 1px 1px 1px #ddd;
    box-shadow: 1px 1px 1px 1px #ddd;
    z-index: 99;
    background-color: #ffffff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    max-width: 130px;
    word-wrap:break-word;
    color: #1E1E1E;
  }
  .tsName:hover .allTsName {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/showReason.vue